import { FolderItem, LsEndpointResponse } from "@/types/fse";
import { ROOT_DRIVE_NAME } from "@/views/drive/consts";
import { isFolderItem } from "@/views/drive/hooks/use-drive-list";

interface CreateBreadCrumbsParams {
  data: LsEndpointResponse;
  isRootDirectory: boolean;
}
export const createBreadCrumbs = ({ isRootDirectory, data }: CreateBreadCrumbsParams) => {
  const rootFolder: FolderItem = {
    id: data.id,
    name: isRootDirectory ? ROOT_DRIVE_NAME : data.name,
    type: "folder",
    permissions: data.permissions,
    current_location: data.current_location,
    file_id: data.file_id,
    owner_id: data.owner_id,
    parent_fs_id: data.parent_fs_id,
    transactions: data.transactions,
    created_at: data.created_at,
    locations: data.locations,
    items: isFolderItem(data) ? data.items : {},
    access: data.access,
  };

  let parentFolder: FolderItem | null = null;
  if (!isRootDirectory) {
    // Determine parent folder based on the current location path
    if (data.current_location.path.length === 0) {
      // Root level
      parentFolder = null;
    } else if (data.current_location.path.length === 1) {
      // Home level - set parent to the first item in the path
      parentFolder = {
        transactions: undefined,
        id: data.current_location.path[0]?.id,
        permissions: data.permissions,
        name: data.current_location.path[0]?.name,
        type: "folder",
        current_location: {
          id: data.current_location.path[0]?.id,
          path: data.current_location.path,
        },
        access: data.access,
        file_id: "",
        owner_id: data.owner_id || "",
        parent_fs_id: null,
        created_at: data.created_at || "",
        locations: [],
        items: {},
      };
    } else {
      // Deeper levels
      const parentPath = data.current_location.path;
      const parentId = parentPath[parentPath.length - 1]?.id;
      parentFolder = {
        transactions: undefined,
        id: parentId,
        access: data.access,
        permissions: data.permissions,
        name: parentPath[parentPath.length - 1]?.name || "Parent Folder",
        type: "folder",
        current_location: {
          id: parentId,
          path: parentPath.slice(0, -1),
        },
        file_id: "",
        owner_id: data.owner_id || "",
        parent_fs_id: parentPath.length > 2 ? parentPath[parentPath.length - 3].id : null,
        created_at: data.created_at || "",
        locations: [],
        items: {},
      };
    }
  }

  return [rootFolder, parentFolder];
};
